import { h, Component } from "preact";
import { route } from "preact-router";
import { translate } from "react-i18next";

import Button from "./Button.js";

class TwoFactorLogin extends Component {
  cancelVerify = () => {
    this.setState({
      step: "initial",
      buttonVerifyAccount: "initial",
      errorEnterPassword: undefined,
      errorEnterCode: undefined,
      password: undefined,
      code: undefined,
    });
    route("/security", true);
  };

  validateForm = (password, username) => {
    this.setState({
      errorEnterPassword: undefined,
      errorEnterCode: undefined,
    });
    if (!password) {
      this.setState({ errorEnterPassword: "You must enter your current password." });
      return false;
    }
    if (!username) {
      this.setState({ errorEnterPassword: "Please try again." });
      return false;
    }
    return true;
  };

  verifyAccount = (e) => {
    this.setState({ buttonVerifyAccount: "loading" });
    const username = this.props.userData.accountInfo.name;

    if (this.validateForm(this.state.password, username)) {
      let bodyValue;
      if (this.state.code === undefined) {
        bodyValue = `{"username": "${username}", "password": "${this.state.password}"}`;
      } else {
        bodyValue = `{"username": "${username}", "password": "${this.state.password}", "code": "${this.state.code}"}`;
      }
      fetch("https://api.hirezstudios.com/acct/loginTwoFactor", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyValue,
      })
        .then((response) => response.json())
        .then((response) => {
          this.setState({ buttonVerifyAccount: "initial" });
          if (response.hasOwnProperty("errors")) {
            this.setState({ errorEnterCode: response.errors[0] });
          } else if (response.hasOwnProperty("webToken")) {
            this.props.callback();
          } else if (response.statusCode === 403) {
            this.setState({ step: "code" });
          } else {
            this.setState({ errorEnterCode: "Something went wrong. Please try again." });
          }
        });
    } else {
      this.setState({ buttonVerifyAccount: "initial" });
    }
  };

  handleKeySubmit = (e) => {
    if (e.key === "Enter") {
      this.verifyAccount();
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      step: "initial",
      buttonVerifyAccount: "initial",
      errorEnterPassword: undefined,
      errorEnterCode: undefined,
      password: undefined,
      code: undefined,
    };
  }

  render() {
    const { t } = this.props;
    return (
      <div className="c-TwoFactorLogin">
        <h4>{t("Login to change your two-factor settings")}</h4>
        {this.state.step === "initial" && (
          <div className="enter-password">
            <label>{t("Password:")}</label>
            <div className="input-wrapper">
              <input
                key="enter-password"
                id="enter-password"
                type="password"
                onKeyPress={this.handleKeySubmit}
                onInput={(e) => this.setState({ password: e.target.value })}
                value={this.state.password}
              />
              <div className="error-enter-password">{t(this.state.errorEnterPassword)}</div>
            </div>
          </div>
        )}
        {this.state.step === "code" && (
          <div className="enter-code">
            <label>{t("Verification Code:")}</label>
            <div className="input-wrapper">
              <input
                key="enter-code"
                id="enter-code"
                type="text"
                onKeyPress={this.handleKeySubmit}
                onInput={(e) => this.setState({ code: e.target.value })}
                value={this.state.code}
              />
              <div className="error-enter-code">{t(this.state.errorEnterCode)}</div>
            </div>
          </div>
        )}
        <div className="buttons-wrapper">
          <Button color="blue" copy={t("Login")} state={this.state.buttonVerifyAccount} onClick={this.verifyAccount} />
          <Button copy={t("Cancel")} onClick={this.cancelVerify} />
        </div>
      </div>
    );
  }
}

export default translate(["common"], { withRef: true })(TwoFactorLogin);



// WEBPACK FOOTER //
// ./components/TwoFactorLogin.js